<ng-progress
  #progressBar
  [trickleSpeed]="10"
  [speed]="10"
  [spinner]="false"
  [thick]="true"
  color="#465dff"
  [ease]="'linear'"
></ng-progress>

<router-outlet />
